package ai.flowstorm.core.video

import ai.flowstorm.common.id.Id
import kotlinx.serialization.Serializable

@Serializable
data class VideoPreviewRequest(
    val avatar: String,
    val voice_id: Id?,
    var text: String
)
